<template>
  <div :class="PanelClass" v-if="isActive">
    
    <div  v-show="priorValid" class="availdiv">
      <div class="horizFlexStretch">
        <div class="product-lookup">
          <input ref="lookupproduct" type="search"  :placeholder="productlookuptext" class="textbox" v-model="productString" @keyup.enter="lookupProduct()" @input="searchchange"/>
          <button class="btn-small actionbutton" @click="lookupProduct">Lookup</button>
        
        </div>
        <div class="horizFlex">
          <div v-if="showReturn" >
            <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to start a return ticket?" title="Return Products" @yes="startreturn" v-if="!isReturn && !isExchange"/>
            <div class="vertcenter">
              <label v-if="isReturn" class="returnlabel">Is Return</label>
            </div>

            
          </div>
          <div v-if="showTaxExempt" >
            <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to make this ticket tax exempt?" title="Set Tax Exempt" @yes="taxexempt" v-if="!ticket.isTaxExempt"/>
            <confirm :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " body="Do you want to make this ticket NOT tax exempt?" title="Set NOT Tax Exempt" @yes="taxexempt(false)" v-if="ticket.isTaxExempt"/>
          </div>
          <div v-if="showReturn">
            <exchange :showButton="trueParam" buttonclass="btn-red-fixed actionbutton " title="Exchange Product" v-if="!isReturn"/>
            
          </div>
        </div>
       
      </div>
      
     <div v-if="pleaseWait">
        <label class="pleasewait" for>Please Wait...</label>
      </div>

      <!-- products from scan -->
      <div class="lineitemavailable" v-if="scannedItems.length!=0">
          <availableitem
            v-for="cartItem in scannedItems"
            v-bind:key="cartItem.id"
            v-bind:cartItem="cartItem" @additem="addScannedItem"
          />
     </div>
     <div class="lineitemavailable" v-if="lookupmessage!=null">
        <label class="margin10">{{ lookupmessage }}</label>
     </div>
      <div>
        <hr>
      </div>
      

      <div class="lineitemavailable" v-if="availableCartItemTypes.length>1" >
          <availableitem :isGroup="trueParam"
            v-for="cartItem in availableCartItemTypes"
            v-bind:key="cartItem.id"
            v-bind:cartItem="cartItem" @additem="setType(cartItem)"
            :showImage='showImagesOnGroupButtons'
          />
     </div>

    

    <!-- products filtered by type -->
     <div class="lineitemavailable scrollbox" v-if="!useProductGroups">
       <availableitem
        v-for="cartItem in filterCartItems"
        v-bind:key="cartItem.ID"
        v-bind:cartItem="cartItem" @additem="addCartItem"
      />
     </div>
      
      <!-- products by group -->
    <div class="lineitemavailable scrollbox" v-if="useProductGroups">
       <availableitem
        v-for="cartItem in cartItemsByGroup"
        v-bind:key="cartItem.ID"
        v-bind:cartItem="cartItem" @additem="addGroupCartItem"
      />
     </div>

    </div>
    <div class="lineitemadded " >
      <div class="cartlines">
        <label for class="text subtitle">Cart</label>
        <CartItem v-for="cartItem in cartItems" v-bind:key="cartItem.id" v-bind:cartItem="cartItem"  @removeitem="removelineitem" @removeitem_exchange="removelineitem_exchange" @refresh="refresh"  @updatequantity="updateitemquantity" @returnitem="returnitem"/>
        <label for class="text text-right totaltext">Subtotal: {{ ticket.subTotal|toCurrency }}</label>
 
        <label for class="text text-right totaltext discountcolor">Discount: {{ ticket.discountAmount|toCurrency }}</label>
        <div class="rightjustify disclink">
          <admindiscountwhole :ticketId="ticket.id" v-if="ShowAdminDiscount" @refresh="refresh"/>
        </div>
          
        <label for class="text text-right totaltext">Tax: {{ ticket.tax|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Due: {{ ticket.total|toCurrency }}</label>
        <label class="eligiblemessage"  v-if="cartEligibleForFA">*All items in Cart Eligible For Financial Aid*</label>
      </div>
      
      <div class="nextbutton">
        <!-- <button class="btn actionbutton" @click="toKitchen" v-show="isValid && ticket.total!=0 && isCulinary">Send to Kitchen</button> -->
        <button class="btn actionbutton" @click="toNext" v-show="isValid && ticket.total!=0 ">Continue to Payment</button>
        <button class="btn actionbutton" @click="process(true)" v-show="isValid && ticket.total==0" :disabled="addingProduct" >Complete Transaction</button>
      </div>
    </div>

    <giftcard :showButton="falseParam" ref="giftcard" @save="saveGiftCard"/>
    <setprice ref="setprice" :minimumUnitPrice="productToGetPrice.minimumUnitPrice" @save="saveProductWithVariablePrice"/>
    <productoptions :showButton="falseParam" ref="productOptions" @save="saveProductWithOptions" :productName="productToGetOptions.name"/>
    <confirmrefundreturn ref="refundreason"  :showButton="falseParam"  body="Please select a reason for the refund" title="Refund Reason" @savereason="saveInventoryActionReason" />   
    <confirm  ref="confirmreturntostock" :showButton="falseParam"  body="Do you want to return all these items to stock?" title="Return" @yes="YesReturn()" @no="NoReturn()"  buttonclass="button buttonprimary"/>   
    <confirmrefundvsreturn ref="selectitemsforrefund"  :showButton="falseParam"   @savereason="saveReasonAndGoAhead" />               
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import CartItem from "../actions/CartItem.vue";
import availableitem from '../actions/availableitem.vue'
import format from '../../style/format.js'
import giftcard from '../actions/giftcard.vue'
import setprice from '../actions/setprice.vue'
import confirm from '../actions/confirm.vue'
import admindiscountwhole from '../actions/admindiscount_whole.vue'
import pos from '../../services/pos.js'
import pay from '../../services/pay.js'
import productoptions  from '../actions/productoptions.vue';
import exchange from '../actions/exchange.vue'
import confirmrefundreturn from '../actions/confirmrefundreturn.vue'
import confirmrefundvsreturn from '../actions/confirmrefundvsreturn.vue';
export default {
  data() {
    return {
      // availableCartItems_filtered:[],
      
      
      trueParam:true,
      falseParam:false,
      

      
     
    };
  },
  props: ["panelIndex"],
  mixins:[format,pos,pay],
  components: {
    CartItem,
    availableitem,
    giftcard,
    admindiscountwhole,
    setprice,
    confirm,
    productoptions,
    exchange,
    confirmrefundreturn,
    confirmrefundvsreturn
  },
  computed: {
    ...mapFields([
            'panels',
            'productlookuptext',
            'lookupmessage'
            

            
        ]),
   
   
  
    isActive: function() {
      return this.panels[this.panelIndex].active;
    },
    isValid: function() {
      return this.panels[this.panelIndex].valid;
    },
    priorValid: function() {
      return this.panels[this.panelIndex - 1].valid;
    },
    PanelClass: function() {
      var classes = "panel-full panel cartfull ";
      if (this.inPayment == true) {
        classes += " panel-unavailable";
      }
      return classes;
    },
    
     
  },
  watch:{
    isActive:function(val){
      if(this.isActive){this.show()}
    }
  },
  methods: {
    
    refresh(){
      this.$emit('refreshticketrebuild')
    },
    show(){
      this.$nextTick(() => {
        this.$refs.lookupproduct.focus();
      })
   },
   searchchange(event){
      if(event.target.value.trim().length===0){
        this.scannedItems=[]
        this.lookupmessage=null
      }
   },
    

    
    
    
    toNext: function() {
      console.log('iaddingproduct ' + this.addingProduct)
      if(this.addingProduct){return}
      //if its a return, and we are doing inventory stuff, ask
      if(this.isReturn && this.AskInventoryForReturn ){
        this.checkReturn()
        return
      }

      console.log('in cart to next' + this.addingProduct)
      this.lookupString=""
      this.panels[2].available=true
      var nextPanelIndex = Number(this.panelIndex) + 1;
      this.$store.dispatch('setActivePanel',nextPanelIndex);
    },
    checkReturn(){
      this.$refs.confirmreturntostock.Show()
    },
    YesReturn(){
      //just go ahead. it will work as is
      console.log('in cart to next')
      this.lookupString=""
      this.panels[2].available=true
      var nextPanelIndex = Number(this.panelIndex) + 1;
      this.$store.dispatch('setActivePanel',nextPanelIndex);
    },
    NoReturn(){
      //pop box that shows checks for each product, which to return to stock, and the reason.
      this.$refs.selectitemsforrefund.Show()
    },
    saveReasonAndGoAhead(reason){
      this.saveInventoryActionReason_only(reason)
      console.log('in cart to next')
      this.panels[2].available=true
      this.lookupString=""
      var nextPanelIndex = Number(this.panelIndex) + 1;
      this.$store.dispatch('setActivePanel',nextPanelIndex);
    },
    toKitchen(){
      this.sendtickettokitchen();
    },
    toComplete: function() {
      this.lookupString=""

      if(this.AutoStartOver)      {
        this.startOver();
      }else{
        var nextPanelIndex = Number(this.panelIndex) + 2;
        this.$store.dispatch('setActivePanel',nextPanelIndex);
      }
      
    },
    startOver: function() {
      this.$store.dispatch('startOver');
    },
    
  },
  
  
};
</script>

<style scoped>

.cartfull {
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto;
  grid-template-areas:
    "itemavailable itemadded";
  padding: 10px;
}

.lineitemavailable {
  /* grid-area: itemavailable; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  
}
.lineitemadded {
  grid-area: itemadded;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 60px;
  grid-template-areas:
    "itemadded"
    "next";
  padding: 10px;


  /* display: flex;
  flex-direction: column;
  border-left: 1px solid gray;
  padding-left:20px;
  margin-left:10px; */
}
.cartlines{
  display: flex;
  flex-direction: column;
  border-left: 1px solid gray;
  padding-left:20px;
  margin-left:10px;
}
.product-lookup {

  display: flex;
  flex-direction: row;
}
.scrollbox{
  max-height:42vh;
  /* max-height:100%; */
  overflow-y: auto;
  overflow-x:hidden;

}
.disclink{
  margin-right:10px;
  font-size:inherit;
}
.returnlabel{
  font-size:larger;
  font-weight:bold;
  margin:0px 0px 0px 0px;
  color:var(--color-red);
}
.vertcenter{
  
  padding-top:10px;
  
}
</style>